<template>
  <div class="home">
    <!-- <div class="header"></div> -->
    <!-- 通讯录 -->
    <el-card class="box-card">
      <div class="address">
        <img src="../../../assets/htImg/icon_tongxunlu.png" alt="" />
        <span>通讯录</span>
      </div>
      <input
        class="inputSearch"
        type="text"
        v-model="text"
        @input.enter="search"
        placeholder="搜索...."
        maxlength="16"
      />
      <div class="contact">
        <div class="ways" v-if="linkmanList.length != 0">
          <div class="way" v-for="(item, index) in linkmanList" :key="index">
            <div class="way-Img">
              <img :src="item.IMGPATH? item.IMGPATH : useImg" alt="" />
            </div>

            <div class="way-user">
              <span v-if="item.XM">{{ item.XM.substring(0, 5) }}</span>
              <span v-else>X某某</span>
              <span v-if="item.LXDH">{{ item.LXDH.substring(0, 11) }}</span>
              <span v-else>未添加号码</span>
            </div>
          </div>
        </div>
        <div class="ways" id="without" v-else>----暂无数据----</div>
      </div>
    </el-card>
    <div class="content">
      <div class="top">
        <div class="fiche bgcolor">
          <div @click="goMember(0)" style="cursor: pointer;">
            <span> {{ !size.rsize ? "NAN" : size.rsize }} </span>
            <span>会员</span>
          </div>
        </div>
        <div class="fiche bgcolor2">
          <div @click="goMember(1)" style="cursor: pointer;">
            <span> {{ !size.csize ? "NAN" : size.csize }} </span>
            <span>专委会</span>
          </div>
        </div>
        <div class="fiche bgcolor3">
          <div @click="goMember(2)" style="cursor: pointer;">
            <span> {{ !size.isize ? "NAN" : size.isize }} </span>
            <span>会员机构</span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <el-card class="meeting">
          <div class="title">
            <img src="../../../assets/htImg/icon_huiyi.png" alt="" />
            <span>会议</span>
          </div>
          <el-divider style="width: 553px"></el-divider>
          <div
            class="applys"
            v-if="meetingList != undefined || meetingList.length != 0"
          >
            <div
              class="apply"
              v-for="(item, index) in meetingList"
              :key="index"
            >
              <div class="apply-left">
                <div class="leftText">
                  <span>{{ item.btitle?item.btitle.substring(0, 9):'-暂无数据-' }}</span>
                  <span>{{ item.content?item.content.substring(0, 11):'-暂无数据-' }}</span>
                  <i v-if="item.content.length>11">..</i>
                </div>
                <div class="leftText2">
                  <span>会议地点:</span>
                  <span>{{ item.address?item.address.substring(0, 15):'地点待定..' }}</span>
                  <i v-if="item.address.length>15">...</i>
                </div>
                <div class="leftText2">
                  <span>会议时间:</span>
                  <span>{{ item.ctime | dateFilter }}</span>
                </div>
              </div>
              <div class="apply-right">
                <span>已报名{{ item.msize }}人</span>
                <div class="condition" @click="meetingChange(item)">
                  <button class="but3" v-if="item.state == 0">已结束</button>
                  <button class="but" v-else-if="item.state == 1">报名</button>
                  <button class="but2" v-else-if="item.state == 2">已报名</button>
                  <button class="but4" v-else-if="item.state == 3">进行中</button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="applys"
            id="without"
            v-if="!meetingList == undefined || meetingList.length == 0"
          >
            --------暂无数据--------
          </div>
        </el-card>
        <el-card class="meeting">
          <div class="title">
            <img
              src="../../../assets/htImg/icon_peixun.png"
              :style="{ width: '24px', height: '24px' }"
              alt=""
            />
            <span>培训</span>
          </div>
          <el-divider style="width: 553px"></el-divider>
          <div
            class="applys"
            v-if="trainList != undefined || trainList.length != 0"
          >
            <div class="apply" v-for="(item, index) in trainList" :key="index">
              <div class="apply-left">
                <div class="leftText">
                  <span>{{ item.btitle?item.btitle.substring(0, 9):'-暂无数据-' }}</span>
                  <span>{{ item.content?item.content.substring(0, 11):'-暂无数据-' }}</span>
                  <i v-if="item.content.length>11">..</i>
                </div>
                <div class="leftText2">
                  <span>会议地点:</span>
                  <span>{{ item.address?item.address.substring(0, 15):'地点待定..' }}</span>
                  <i v-if="item.address.length>15">...</i>
                </div>
                <div class="leftText2">
                  <span>会议时间:</span>
                  <span>{{ item.ctime | dateFilter }}</span>
                </div>
              </div>
              <div class="apply-right">
                <span>已报名{{ item.msize }}人</span>
                <div class="condition" @click="trainChange(item)">
                  <button class="but3" v-if="item.state == 0">已结束</button>
                  <button class="but" v-else-if="item.state == 1">报名</button>
                  <button class="but2" v-else-if="item.state == 2">已报名</button>
                  <button class="but4" v-else-if="item.state == 3">进行中</button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="applys"
            id="without"
            v-if="trainList == undefined || trainList.length == 0"
          >
            --------暂无数据--------
          </div>
        </el-card>
      </div>
    </div>
    <!-- 对话框 -->
    <applyDialog ref="applyDialog" />
  </div>
</template>

<script>
import { infoData, inquireData } from "../../../api/backstage";
import applyDialog from "../../common/applyDialog";
export default {
  components: {
    applyDialog,
  },
  data() {
    return {
      centerDialogVisible: false,
      useImg: require("../../../assets/htImg/pic_touxiangmoren.png"),
      text: "",
      size: {
        rsize: "",
        csize: "",
        isize: "",
      },
      meetingList: [],
      trainList: [],
      linkmanList: [],
      AID: "",
    };
  },
  created() {
    this.$forceUpdate();
    this.initial();
  },
  methods: {
    goMember(value){
      this.$router.push("/index/member?id="+value);
    },
    search() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        inquireData(this.text).then((res) => {
          if (this.text != "") {
            this.linkmanList = res.list0;
          } else {
            this.linkmanList = res.list0;
          }
        });
      }, 300);
    },
    meetingChange(item) {
      this.$refs.applyDialog.centerDialogVisible = true;
      this.$refs.applyDialog.tableData = item;
    },
    trainChange(item) {
      this.$refs.applyDialog.centerDialogVisible = true;
      this.$refs.applyDialog.tableData = item;
    },
    initial() {
      infoData({
        AID: this.aid,
      }).then((res) => {
        if (res.code == 1) {
          this.size.rsize = res.rsize;
          this.size.csize = res.csize;
          this.size.isize = res.isize;
          this.linkmanList = res.list0;
          this.meetingList = res.list1;
          this.trainList = res.list2;
        } else if (res.code == 1001) {
          this.$alert("请先登录", "警告", {
            confirmButtonText: "确定",
            type: "warning",
            callback: () => {
              this.$router.push("/login");
            },
          });
        } else if (res.code == -1) {
          this.$message.error("数据异常");
        }
      });
    },
  },
  filters: {
    dateFilter(i) {
      var myDate = new Date(i);
      return (
        myDate.getFullYear() +
        "." +
        (myDate.getMonth() + 1) +
        "." +
        myDate.getDate() +
        " " +
        myDate.getHours() +
        ":" +
        myDate.getMinutes()
      );
    },
  },
  computed: {
    aid() {
      return this.$store.state.userInfo.AID;
    },
  },
};
</script>

<style scoped lang="less">
.el-divider--horizontal {
  width: 553px;
}
.home {
  display: flex;
}
.box-card {
  width: 270px;
  height: 903px;
  margin-left: 33px;
  margin-top: 22px;
  .address {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 22px;
      margin-right: 12px;
    }
    span {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .inputSearch {
    width: 230px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #bdbdbd;
    border-radius: 20px;
    font-size: 18px;
    padding-right: 36px;
    text-indent: 1em;
    background: url("../../../assets/htImg/icon_sousuo.png") no-repeat;
    background-size: 23px 23px;
    background-position: 193px 6px;
    margin-top: 28px;
    margin-bottom: 19px;
  }
  .contact {
    width: 230px;
    height: 730px;
    overflow-y: scroll;
    margin: 0 auto;
    .way {
      display: flex;
      align-items: center;
      width: 100%;
      height: 73px;
      .way-Img {
        width: 51px;
        height: 52px;
        border-radius: 25px;
        margin-right: 22px;
        img {
          width: 51px;
          height: 52px;
          border-radius: 25px;
          object-fit: cover;
        }
      }

      .way-user {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        height: 100%;
        border-bottom: 1px solid #e1e1e1;
        span:nth-child(1) {
          font-size: 20px;
          font-weight: bold;
        }
        span:nth-child(2) {
          font-size: 16px;
          color: #333333;
          letter-spacing: 2px;
          margin-top: 6px;
        }
      }
    }
  }
}
.content {
  width: 1217px;
  height: 903px;
  margin-left: 33px;
  margin-top: 22px;
  .top {
    width: 100%;
    height: 160px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    .fiche {
      width: 375px;
      height: 160px;
      border-radius: 10px;
      position: relative;
      div {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: 95px;
        top: 26px;
        span:nth-child(1) {
          font-size: 60px;
          color: #fefefe;
        }
        span:nth-child(2) {
          font-size: 22px;
          font-weight: bold;
          color: #fefefe;
          text-align: center;
        }
      }
    }
    .bgcolor {
      background: url("../../../assets/htImg/pic_huiyuankuang.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .bgcolor2 {
      background: url("../../../assets/htImg/pic_zhuanweihui.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .bgcolor3 {
      background: url("../../../assets/htImg/pic_huiyuanjigou.png") no-repeat
        center;
      background-size: 100% 100%;
    }
  }
  .bottom {
    width: 1217px;
    height: 690px;
    display: flex;
    justify-content: space-between;
    .meeting {
      width: 586px;
      height: 100%;
      .title {
        display: flex;
        align-items: center;
        img {
          width: 28px;
          height: 19px;
          margin-left: 4px;
          margin-right: 8px;
        }
        span {
          font-size: 20px;
          font-weight: bold;
        }
      }
      .applys{
        width: 562px;
        height: 592px;
        overflow-y: scroll;
      }
      .apply {
        // width: 553px;
        width: 100%;
        height: 130px;
        border: 1px solid #e5e5e5;
        display: flex;
        margin-bottom: 18px;
        .apply-left {
          margin: 21px 56px 0 21px;
          width: 70%;
          .leftText {
            margin-bottom: 22px;
            span:nth-child(1) {
              font-size: 20px;
              font-weight: bold;
              color: #343436;
              margin-right: 12px;
            }
            span:nth-child(2) {
              font-size: 16px;
              font-weight: 500;
              color: #666666;
            }
          }
          .leftText2 {
            margin-bottom: 5px;
            span:nth-child(1) {
              font-size: 16px;
              color: #b6b6b6;
              margin-right: 10px;
            }
            span:nth-child(2) {
              font-size: 18px;
              color: #333333;
            }
          }
        }
        .apply-right {
          margin-top: 26px;
          span {
            display: block;
            font-size: 14px;
            color: #999999;
            margin-bottom: 35px;
          }
          button {
            width: 78px;
            height: 36px;
            border-radius: 10px;
            font-size: 18px;
            cursor: pointer;
          }
          .but {
            color: #ffffff;
            background: #b82925;
          }
          .but2 {
            color: #666666;
            background: #ffffff;
            border: 1px solid #bababa;
          }
          .but3 {
            color: #ffffff;
            background: #bababa;
          }
          .but4{
            color: #ffffff;
            background: orange;
          }
        }
      }
    }
  }
}
</style>
